// Bank codes follow DOKU's supported-bank directory for domestic transfers.
// Keep the code alongside the display name so the same profile data can be
// reused by the Settlement Bank Account API when that integration is enabled.
export const INDONESIAN_BANKS = [
  ["002", "Bank BRI"],
  ["008", "Bank Mandiri"],
  ["009", "Bank BNI"],
  ["011", "Bank Danamon"],
  ["011SY", "Bank Danamon Syariah"],
  ["013", "Bank Permata"],
  ["013SY", "Bank Permata Syariah"],
  ["014", "Bank BCA"],
  ["016", "Bank Maybank Indonesia"],
  ["016SY", "Bank Maybank Syariah"],
  ["019", "Bank Panin"],
  ["022", "Bank CIMB Niaga"],
  ["022SY", "Bank CIMB Niaga Syariah"],
  ["023", "Bank UOB Indonesia"],
  ["028", "Bank OCBC"],
  ["028SY", "Bank OCBC Syariah"],
  ["031", "Citibank"],
  ["032", "JPMorgan Chase Bank"],
  ["033", "Bank of America"],
  ["036", "Bank CCB Indonesia"],
  ["037", "Bank Artha Graha Internasional"],
  ["042", "MUFG Bank"],
  ["046", "Bank DBS Indonesia"],
  ["047", "Bank Resona Perdania"],
  ["048", "Bank Mizuho Indonesia"],
  ["050", "Standard Chartered Bank"],
  ["054", "Bank Capital Indonesia"],
  ["057", "Bank BNP Paribas Indonesia"],
  ["061", "Bank ANZ Indonesia"],
  ["067", "Deutsche Bank"],
  ["069", "Bank of China"],
  ["076", "Bank Bumi Arta"],
  ["087", "Bank HSBC Indonesia"],
  ["095", "Bank JTrust Indonesia"],
  ["097", "Bank Mayapada Internasional"],
  ["110", "Bank BJB"],
  ["111", "Bank DKI"],
  ["111SY", "Bank DKI Syariah"],
  ["112", "Bank BPD DIY"],
  ["112SY", "Bank BPD DIY Syariah"],
  ["113", "Bank Jateng"],
  ["113SY", "Bank Jateng Syariah"],
  ["114", "Bank Jatim"],
  ["114SY", "Bank Jatim Syariah"],
  ["115", "Bank Jambi"],
  ["115SY", "Bank Jambi Syariah"],
  ["116", "Bank Aceh Syariah"],
  ["117", "Bank Sumut"],
  ["117SY", "Bank Sumut Syariah"],
  ["118", "Bank Nagari"],
  ["118SY", "Bank Nagari Syariah"],
  ["119", "Bank Riau Kepri Syariah"],
  ["120", "Bank Sumsel Babel"],
  ["120SY", "Bank Sumsel Babel Syariah"],
  ["121", "Bank Lampung"],
  ["122", "Bank Kalsel"],
  ["122SY", "Bank Kalsel Syariah"],
  ["123", "Bank Kalbar"],
  ["123SY", "Bank Kalbar Syariah"],
  ["124", "Bank Kaltimtara"],
  ["124SY", "Bank Kaltimtara Syariah"],
  ["125", "Bank Kalteng"],
  ["126", "Bank Sulselbar"],
  ["126SY", "Bank Sulselbar Syariah"],
  ["127", "Bank SulutGo"],
  ["128", "Bank NTB Syariah"],
  ["129", "Bank BPD Bali"],
  ["130", "Bank NTT"],
  ["131", "Bank Maluku Malut"],
  ["132", "Bank Papua"],
  ["133", "Bank Bengkulu"],
  ["134", "Bank Sulteng"],
  ["135", "Bank Sultra"],
  ["137", "Bank Banten"],
  ["146", "Bank of India Indonesia"],
  ["147", "Bank Muamalat Indonesia"],
  ["151", "Bank Mestika Dharma"],
  ["152", "Bank Shinhan Indonesia"],
  ["153", "Bank Sinarmas"],
  ["153SY", "Bank Nano Syariah"],
  ["157", "Bank Maspion Indonesia"],
  ["161", "Bank Ganesha"],
  ["164", "Bank ICBC Indonesia"],
  ["167", "Bank QNB Indonesia"],
  ["200", "Bank BTN"],
  ["212", "Bank Woori Saudara"],
  ["213", "Bank SMBC Indonesia (Jenius)"],
  ["405", "Bank Syariah Nasional"],
  ["425", "Bank BJB Syariah"],
  ["426", "Bank Mega"],
  ["441", "Bank KB Bukopin"],
  ["451", "Bank Syariah Indonesia (BSI)"],
  ["459", "Krom Bank"],
  ["472", "Bank Saqu (Bank Jasa Jakarta)"],
  ["484", "Bank KEB Hana Indonesia"],
  ["485", "Bank MNC Internasional"],
  ["490", "Bank Neo Commerce"],
  ["494", "Bank Raya Indonesia"],
  ["498", "Bank SBI Indonesia"],
  ["501", "blu by BCA Digital"],
  ["503", "Bank Nationalnobu"],
  ["506", "Bank Mega Syariah"],
  ["513", "Bank Ina Perdana"],
  ["517", "Bank Panin Dubai Syariah"],
  ["520", "Bank Prima Master"],
  ["521", "Bank KB Bukopin Syariah"],
  ["523", "Bank Sahabat Sampoerna"],
  ["526", "Bank Oke Indonesia"],
  ["531", "Bank Amar Indonesia"],
  ["535", "SeaBank Indonesia"],
  ["536", "BCA Syariah"],
  ["542", "Bank Jago"],
  ["542SY", "Bank Jago Syariah"],
  ["547", "Bank BTPN Syariah"],
  ["548", "Bank Multiarta Sentosa"],
  ["553", "hibank Indonesia"],
  ["555", "Bank Index Selindo"],
  ["562", "Superbank Indonesia"],
  ["564", "Bank Mandiri Taspen"],
  ["566", "Bank Victoria International"],
  ["567", "Allo Bank Indonesia"],
  ["945", "Bank IBK Indonesia"],
  ["947", "Bank Aladin Syariah"],
  ["949", "Bank CTBC Indonesia"],
  ["950", "Bank Commonwealth"],
].map(([code, name]) => ({ code, name }));

export function findBankByName(name) {
  const normalize = (value) => String(value || "")
    .toLocaleLowerCase("id-ID")
    .replace(/\([^)]*\)/g, " ")
    .replace(/\b(pt|bank|indonesia)\b/g, " ")
    .replace(/[^a-z0-9]+/g, " ")
    .trim();
  const normalized = normalize(name);
  if (!normalized) return undefined;
  const acronym = String(name || "").match(/\(([^)]+)\)/)?.[1]?.toLocaleLowerCase("id-ID");
  return INDONESIAN_BANKS.find((bank) => {
    const bankAcronym = bank.name.match(/\(([^)]+)\)/)?.[1]?.toLocaleLowerCase("id-ID");
    return normalize(bank.name) === normalized || bankAcronym === normalized || (acronym && bankAcronym === acronym);
  });
}
